export default {
  legend: "Field Set",
  key: "fieldset",
  type: "fieldset",
  label: "",
  input: false,
  tableView: false,
  components: []
};
